import { render, staticRenderFns } from "./SystemModule.vue?vue&type=template&id=767e1860&scoped=true"
import script from "./SystemModule.vue?vue&type=script&lang=js"
export * from "./SystemModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767e1860",
  null
  
)

export default component.exports